import * as tslib_1 from "tslib";
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { RequestService } from '../request/request-onboarding.service';
import * as i0 from "@angular/core";
import * as i1 from "../request/request-onboarding.service";
import * as i2 from "../external/biocatch/biocatch.service";
import * as i3 from "../abre-cuentas/abre-cuentas.service";
var SignOnService = /** @class */ (function () {
    function SignOnService(requestService, bioCatchService, abreCuentasService) {
        this.requestService = requestService;
        this.bioCatchService = bioCatchService;
        this.abreCuentasService = abreCuentasService;
    }
    /**
     * Validación de aceptación de términos y condiciones, registro en la bítacora
     *
     * *Terms and conditions acceptance validation*
     */
    SignOnService.prototype.termsAndConditions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deviceInfo, transactionInfo, ipBiocatch, body;
            return tslib_1.__generator(this, function (_a) {
                try {
                    deviceInfo = this.abreCuentasService.getDeviceInfo();
                    transactionInfo = this.abreCuentasService.getTransactionInfo();
                    ipBiocatch = this.bioCatchService.getCurrentScoreIp();
                    if (deviceInfo !== undefined && deviceInfo !== null) {
                        body = {
                            device: tslib_1.__assign({}, deviceInfo, { ip: ipBiocatch }),
                            terms_type: 'product_terms',
                            transaction: tslib_1.__assign({}, transactionInfo, { transaction_type: 'onboarding-angular-fe' }),
                        };
                        return [2 /*return*/, this.requestService.saveDataInBitacora(body)];
                    }
                }
                catch (error) {
                    console.error(error);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de configuración
     *
     * *Async Function that sends config*
     *
     * @type {function}
     * @returns {Promise}
     */
    SignOnService.prototype.createCasePerformSolicitation = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService.createCasePerformSolicitation(body, solicitationId)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de configuración
     *
     * *Async Function that sends config*
     *
     * @type {function}
     * @returns {Promise}
     */
    SignOnService.prototype.getCaseSolicitationInfo = function (solicitationId, productType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.requestService.getCaseSolicitationInfo(solicitationId, productType)
                            .then(function (res) { return resolve(res); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    SignOnService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SignOnService_Factory() { return new SignOnService(i0.ɵɵinject(i1.RequestService), i0.ɵɵinject(i2.BioCatchService), i0.ɵɵinject(i3.AbreCuentasService)); }, token: SignOnService, providedIn: "root" });
    return SignOnService;
}());
export { SignOnService };
